import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const DirittoRoundIcon = ({ className, color = Color.Primary500 }: NewIconProps) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill={color} />
    <path
      d="M8.50884 3.16569L8.78506 6.54209C8.41436 6.29279 7.78634 6.09732 7.14851 6.15641C5.48976 6.31223 4.35733 7.87979 4.51455 9.80341C4.66384 11.6249 5.99878 12.6972 7.53753 12.7486C8.36489 12.7762 9.14955 12.3855 9.63218 11.9365L11 11.8052L10.2797 3L8.50884 3.16569ZM6.61079 8.39398C6.83897 8.06044 7.17448 7.86343 7.58123 7.82425C7.62777 7.81983 7.67374 7.81756 7.71913 7.81746C8.46542 7.81746 9.02291 8.41804 9.09503 9.32516C9.17147 10.2875 8.65582 11.0143 7.84115 11.0927C7.43454 11.132 7.07279 11.0019 6.79556 10.717C6.52958 10.4436 6.36284 10.0441 6.32736 9.59082C6.29144 9.14004 6.39198 8.71394 6.61079 8.39398Z"
      fill="white"
    />
  </svg>
);
